import toast from 'react-hot-toast';
import apiConfig from '@/config/url-api';
import useAuthStore from '@/store/auth';
import { queryClient } from '@/config/queryClient';

let isHandling401 = false;

export const isSessionExpired = (): boolean => isHandling401;

export const resetSessionExpired = (): void => {
  isHandling401 = false;
};

export const handleUnauthorized = (_error?: any) => {
  if (typeof window === 'undefined') return;

  // Prevent multiple executions when multiple API requests return 401 concurrently
  if (isHandling401) return;
  isHandling401 = true;

  // 1. Cancel in-flight queries and clear react-query cache immediately so no further requests fire
  try {
    queryClient.cancelQueries();
    queryClient.clear();
  } catch (e) {
    console.error('[AUTH 401] Error clearing queryClient:', e);
  }

  // 2. Clear token & user from localStorage and set session expired flag
  try {
    localStorage.removeItem(apiConfig.auth.storageTokenKeyName);
    localStorage.removeItem(apiConfig.auth.storageUserKeyName);
    sessionStorage.setItem('auth_session_expired', '1');
  } catch (e) {}

  // 3. Clear auth store state in Zustand
  try {
    useAuthStore.getState().logout();
  } catch (e) {}

  // 4. Dismiss all pending toasts and show single 401 error toast
  toast.dismiss();
  toast.error('Sesi Anda telah berakhir, silakan login kembali.', {
    id: 'auth-session-expired',
    duration: 4000,
  });

  // 5. Redirect to login page if not already there
  const currentPath = window.location.pathname;
  if (!currentPath.startsWith('/login')) {
    const fullUrl = window.location.pathname + window.location.search;
    const returnUrl = encodeURIComponent(fullUrl);
    setTimeout(() => {
      window.location.replace(`/login?returnUrl=${returnUrl}`);
    }, 100);
  }
};
